export const GOOGLE_RECAPTCHA_KEY = '6LcHgokhAAAAAG83VxnDjrGKwwn0A768JjsdCu4H';